import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import logo from "./imeges/logo1.svg";
import { useTheme } from "./ThemeContext";
import { Row } from "react-bootstrap";

const Footer = () => {
  const { theme } = useTheme();
  return (
    
    <footer className=" text-white" style={{backgroundColor: theme === "dark" ? "#1e1e1e" : "#001351"}} >
      <div className="container">
        <Row>
          {/* Industries */}
          <div className="col-md-3 col-sm-6 mb-3 mt-3">
            <h5 className="fw-bold">Domain Specific Solutions</h5>
            <ul className="list-unstyled">
              <li>Diagnostic Laboratories</li>
              <li>Hospitals & Clinics</li>
              <li>Hospital Attached Labs</li>
              <li>Healthcare Analytics</li>
              <li>AI based Digital Health Agents</li>
              
            </ul>
          </div>

          {/* Services */}
          <div className="col-md-3 col-sm-6 mb-3 mt-3">
            <h5 className="fw-bold">Services</h5>
            <ul className="list-unstyled">
              <li>AI based Digital Agents</li>
              {/* <li>Cloud</li> */}
              <li>Dev OPS</li>
              <li>Consulting Services</li>
              <li>Data Engineering & Analytics</li>
              <li>IoT Solutions</li>
            </ul>
          </div>

          {/* Insights */}
          <div className="col-md-3 col-sm-6 mb-3 mt-3">
            <h5 className="fw-bold">Insights</h5>
            <ul className="list-unstyled">
              <li>Customer Stories</li>
              <li>Cloud</li>
              <li>Blockchain</li>
              <li>IoT</li>
              <li>Metaverse</li>
              <li>Future of Work</li>
              <li>Health and Wellness</li>
              <li>Sustainability</li>
            </ul>
          </div>

          {/* More Information */}
          
          
          <div className="col-md-3 col-sm-6 mb-3 mt-3">
            <h5 className="fw-bold">More information</h5>
            <ul className="list-unstyled">
              <li>Careers</li>
            </ul>
          </div>
          </Row>
      </div>
      {/* Copyright */}
      <div className="d-flex align-items-center justify-content-start " style={{ backgroundColor: theme === "dark" ? "#1e1e1e" : "#001351",  color: 'white', padding: '20px' }}>
        <img
          src={logo}
          loading="lazy"
          width="150"
          height="90"
          filter= 'invert(1)'
          alt="IT Company logo"
          className="ms-3"
        />
   

        <p className="mb-0" style={{ marginLeft: '10%' }}>
          © 2025 BOT BRIDGE Technology Private Limited. All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
